import React from 'react';
import { Checkbox } from '@material-ui/core';
import { colors } from '@/styles';
import { ChildRow as ChildRowBox, SelectCell, KebabCell, ChildCell, Pill, IdLink } from './blocks';
import RowMenu from './RowMenu';

const GreenCheckbox = (props) => (
    <Checkbox size="small" style={{ padding: 0, color: colors.greens.primary }} {...props} />
);

// Renders one config-defined child column cell. variant: 'id' | 'pill' | (default) text.
const CellRenderer = ({ column, child, row }) => {
    const value = column.get(child, row);
    if (column.variant === 'id') return <IdLink>{value}</IdLink>;
    if (column.variant === 'pill')
        return (
            <Pill color={value.color} title={value.title}>
                {value.label}
            </Pill>
        );
    return <ChildCell>{value}</ChildCell>;
};

const GridChildRow = ({ row, child, columns, gridTemplate, selectable, selected, onToggle, menuActions = [] }) => (
    <ChildRowBox columns={gridTemplate}>
        <SelectCell>{selectable ? <GreenCheckbox checked={selected} onChange={onToggle} /> : null}</SelectCell>
        {columns.map((column) => (
            <CellRenderer key={column.key || column.header} column={column} child={child} row={row} />
        ))}
        <KebabCell>{menuActions.length ? <RowMenu actions={menuActions} /> : null}</KebabCell>
    </ChildRowBox>
);

export default GridChildRow;
